export const calculateInvoiceIVA = (totalPrice: number, ivaPercentage: number): number => {
  return (totalPrice * ivaPercentage) / 100;
};

export const calculateInvoiceTotalWithIVA = (totalPrice: number, ivaPercentage: number): number => {
  return totalPrice + calculateInvoiceIVA(totalPrice, ivaPercentage);
};
